import useEnabledFeature from '../../useEnabledFeature';

const useDropship = (): boolean => {
  const dropshipFeatureEnabled = useEnabledFeature('cat-dropship');

  return dropshipFeatureEnabled;
};

export default useDropship;
